import SliderBase from "./slider-base";
import {Autoplay} from "swiper";
import {BREAKPOINT_XS, BREAKPOINT_MD, BREAKPOINT_LG, BREAKPOINT_XL} from "../globals";

const SLIDER_DELAY = 2000;

export default class SliderLogos extends SliderBase {
	static initAll() {
		/** @var {SwiperOptions} **/
		const config = {
			modules: [Autoplay],
			loop: true,
			slidesPerView: 2,
			breakpoints: {
				[BREAKPOINT_XS]: {
					slidesPerView: 3,
				},
				[BREAKPOINT_MD]: {
					slidesPerView: 4,
				},
				[BREAKPOINT_LG]: {
					slidesPerView: 5,
				},
				[BREAKPOINT_XL]: {
					slidesPerView: 6,
				},
			},
			autoplay: {
				delay: SLIDER_DELAY,
				disableOnInteraction: false,
			},
		};

		this.initAllWith('.slider-logos', config, true);
	}
}
